import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  orderSummaryButtonTooltip: {
    defaultMessage: 'Order Summary',
    description: 'Tooltip for a button that opens and closes the order summary panel',
    id: 'SG8QS2',
  },
  shipmentsButtonTooltip: {
    defaultMessage: '<formatterCount>{count}</formatterCount> {count, plural, one {Shipment} other {Shipments}}',
    description: 'Tooltip for a button that opens and closes the shipments panel',
    id: '1sPykR',
  },
  returnsButtonTooltip: {
    defaultMessage: '<formatterCount>{count}</formatterCount> {count, plural, one {Return} other {Returns}}',
    description: 'Tooltip for a button that opens and closes the returns panel',
    id: 'esEbpy',
  },
  iconCount: {
    defaultMessage: '{isOverflow, select, true {999+} other {{count}}}',
    description: 'Count for the number of shipments or returns',
    id: 'Gh2jnC',
  },
});
